const api = process.env.VUE_APP_API_BASE_URL
const kapApi = process.env.VUE_APP_KAP_API_URL
const bbs = process.env.VUE_APP_BBS_BASE_URL
const h5 = process.env.VUE_APP_H5_BASE_URL
const merchantapi = process.env.VUE_APP_MERCHANTAPI
const qiniu = 'https://upload.qiniup.com'
module.exports = {
    api,
    kapApi,
    h5,
    bbs,
    merchantapi,
    qiniu
}